import "./ListFilter.css";

export default function ListFilter({
    searchInput,
    setSearchInput,
    handleKeyPress,
    handleSearch,
    sortOrder,
    setSortOrder,
}) {
    return (
        <div className="listFilterContainer">
            <div>
                <input
                    type="text"
                    name="search"
                    placeholder="Search titles..."
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    onKeyDown={handleKeyPress}
                />
                <button onClick={handleSearch}>Search</button>
            </div>
            <select onChange={(e) => setSortOrder(e.target.value)} value={sortOrder} name="sort">
                <option value="newest">Newest First</option>
                <option value="oldest">Oldest First</option>
            </select>
        </div>
    );
}
